import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Input, message } from 'antd';

const EditableContext = React.createContext(null);

export const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

export const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    setIsvalid,
    isValid,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setIsvalid(!isValid)
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            if (dataIndex === 'price_to_paid' && values[dataIndex] < 0) {
                message.error('ราคาที่จะจ่ายต้องเป็นค่าบวก');
                return;
            }
            if (dataIndex === 'price_to_paid' && values[dataIndex] > (parseFloat(record.item_totalprice) - parseFloat(record.item_paid))) {
                message.error('ราคาที่จะจ่าย เกินราคาคงเหลือ');
                return;
            }

            if (dataIndex === 'price_to_paid' && (record.item_remain === record.times_to_use)) {
                if ((parseFloat(record.item_totalprice - record.item_paid) - values[dataIndex]) !== 0) {
                    message.error(`กรุณาจ่ายเงินให้ครบก่อนใช้บริการรอบสุดท้าย `);
                    return;
                }
            }
            if (dataIndex === 'price_to_paid' && parseFloat(values[dataIndex]) === 0 && parseInt(record.times_to_use) === 0) {
                message.error(`ราคาที่จะจ่ายต้องเป็นค่าบวกหากจำนวนครั้งที่ใช้เป็น 0 `);
                return;
            }
            if (dataIndex === 'times_to_use' && values[dataIndex] > record.item_remain) {
                message.error(`จำนวนครั้งที่ใช้ต้องไม่มากกว่าจำนวนครั้งคงเหลือ `);
                return;
            }

            if (dataIndex === 'times_to_use' && values[dataIndex] <= 0 && parseFloat(record.price_to_paid) === 0) {
                message.error(`จำนวนครั้งที่ใช้ต้องเป็นค่าบวกหากราคาที่จะจ่ายเป็น 0`);
                return;
            }
            if (dataIndex === 'times_to_use' && values[dataIndex] < 0 && parseFloat(record.price_to_paid) !== 0) {
                message.error(`จำนวนครั้งที่ใช้ต้องเป็นค่าตั้งเเต่ 0`);
                return;
            }


            if (isNaN(values[dataIndex])) {
                message.error('กรุณาใส่เฉพาะตัวเลข');
                return;
            }

            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `กรุณากรอก ${title}`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} autoComplete='off' className='w-[5rem]' />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};
